module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sendMsg"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.greenBtn),
      expression: "greenBtn"
    }]
  }, [_c('button', {
    staticClass: "button green sendBtn",
    on: {
      "click": _vm.sendBtn
    }
  }, [_vm._v("发送通知")]), _vm._v(" "), _c('div', {
    staticClass: "MsgContent"
  }, [_vm._l((_vm.pageList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "msg"
    }, [_c('div', {
      staticClass: "message"
    }, [_c('img', {
      attrs: {
        "src": require("./../../assets/img/msg.png"),
        "alt": "消息"
      }
    }), _vm._v(" "), _c('pre', {
      ref: "msgshow",
      refInFor: true,
      staticClass: "main_contents"
    }, [_vm._v(_vm._s(item.content.content))]), _vm._v(" "), (item.show_details == 'false') ? _c('i', {
      on: {
        "click": function($event) {
          _vm.showMsg(item, index)
        }
      }
    }, [_vm._v("展开")]) : _vm._e(), _vm._v(" "), (item.show_details == 'true') ? _c('i', {
      on: {
        "click": function($event) {
          _vm.showMsg(item, index)
        }
      }
    }, [_vm._v("收起")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "receiveMsg clearfix"
    }, [_c('span', {
      staticClass: "receiveClass fl",
      attrs: {
        "title": item.classNames
      }
    }, [_vm._v("发送班级 : " + _vm._s(item.classNames))]), _vm._v(" "), _c('span', {
      staticClass: "receiveTime fr"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(item.publishDate, 'yyyy-MM-dd hh:mm')))])])])
  }), _vm._v(" "), (_vm.loading && _vm.pageIndex !== _vm.pageCount) ? _c('div', {
    staticClass: "loading_books"
  }, [_c('div', {
    staticClass: "load_line"
  }), _vm._v(" "), _c('p', [_vm._v("正在加载中...")])]) : _vm._e()], 2), _vm._v(" "), _c('notice', {
    attrs: {
      "params": _vm.noticParams,
      "isNotice": _vm.isNotice
    },
    on: {
      "isConfirm": _vm.isConfirm
    }
  })], 1), _vm._v(" "), _c('send', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.greenBtn),
      expression: "!greenBtn"
    }],
    on: {
      "backMsg": _vm.backMsg
    }
  }), _vm._v(" "), (_vm.pageList.length == 0) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "100px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/img/noMessage.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#A6A6A6",
      "margin-top": "10px"
    }
  }, [_vm._v("您暂时还没发送校讯通知哦~")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-808ab238","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/schoolMsg/sendMsg.vue
// module id = 1225
// module chunks = 1